import React from 'react';
import { Row, Col, Container } from 'react-bootstrap';
import CookieConsent from "react-cookie-consent";

class Footer extends React.Component {
    render() {
        return (
            <Container>
                <CookieConsent location="bottom" buttonText="Gerai" cookieName="myAwesomeCookieName2" style={{ background: "#2B373B" }} buttonStyle={{ color: "#4e503b", fontSize: "13px" }} expires={150}>
                    Šiame svetainėje naudojami slapukai. Tęsdami naršymą, sutinkate su slapukų naudojimu.
                </CookieConsent>
                <Row>
                    <Col md={8} className='regular-text shadowed-text'>© 2025 Virtuvesklubas.eu Visos teisės saugomos.</Col>
                    <Col md={4} className='regular-text shadowed-text' style={{ textAlign: 'right' }}>© EPSILON PLIUS, UAB. 2025</Col>
                </Row>
            </Container>
        );
    }
}

export default Footer;